var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57145 8.57143H15.4286M8.57145 12H15.4286M8.57145 15.4286H15.4286M18.8572 17.7143V6.28571C18.8572 5.67951 18.6164 5.09812 18.1877 4.66947C17.759 4.24082 17.1777 4 16.5715 4H7.4286C6.82239 4 6.24101 4.24082 5.81235 4.66947C5.3837 5.09812 5.14288 5.67951 5.14288 6.28571V17.7143C5.14288 18.3205 5.3837 18.9019 5.81235 19.3305C6.24101 19.7592 6.82239 20 7.4286 20H16.5715C17.1777 20 17.759 19.7592 18.1877 19.3305C18.6164 18.9019 18.8572 18.3205 18.8572 17.7143V17.7143Z",
    stroke: "#aa4f4f",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57145 8.57143H15.4286M8.57145 12H15.4286M8.57145 15.4286H15.4286M18.8572 17.7143V6.28571C18.8572 5.67951 18.6164 5.09812 18.1877 4.66947C17.759 4.24082 17.1777 4 16.5715 4H7.4286C6.82239 4 6.24101 4.24082 5.81235 4.66947C5.3837 5.09812 5.14288 5.67951 5.14288 6.28571V17.7143C5.14288 18.3205 5.3837 18.9019 5.81235 19.3305C6.24101 19.7592 6.82239 20 7.4286 20H16.5715C17.1777 20 17.759 19.7592 18.1877 19.3305C18.6164 18.9019 18.8572 18.3205 18.8572 17.7143V17.7143Z",
    stroke: "#aa4f4f",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.7f37acad6972d3c1ff09a58b442ec482.svg";
export { ForwardRef as ReactComponent };